import { isPresent } from 'utils/isPresent';
import React, {PureComponent} from 'react';
import Grid from "housecall-ui/dist/DesignSystem/Layout/Grid/Grid"
import ui from 'redux-ui';
import withStyles from 'housecall-ui/dist/DesignSystem/Styles/withStyles';
import {connect} from 'react-redux';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button'
import {FieldArray} from 'redux-form'
import {OPTION_USA} from "../../Common/Form/AddressData";
import AddressExpansionPanel from "./AddressExpansionPanel.jsx";
import EachAddressContent from "./EachAddressContent.jsx";
import {
    getCompanyCountry,
    updateBillingAddress,
    UPDATE_ADDRESS_COUNTRY,
    UPDATE_EXPANDED_ADDRESS
} from "./Redux/Actions";
import SectionTitle from './SectionTitle';
import AddressIcon from 'housecall-ui/dist/IconsAndImages/Icons/LocationOn'

const styles = (theme) => ({
    addAddressButtonOneAddress: {
        margin: '20px 0 10px 0',
    },
    buttonMargin: {
        marginTop: 5
    },
    addressPadding: {
        paddingTop: 12
    },
})

@connect(
    state => ({
        hasParentAddress: isPresent(state.addOrEditCustomer.parentCustomer) && isPresent(state.addOrEditCustomer.parentCustomer.all_addresses)
    }),
    dispatch => ({
        getCompanyCountry: (defaultCountry) => {
            dispatch(getCompanyCountry(defaultCountry))
        },
        updateBillingAddress: (dragIndex, hoverIndex) => {
            dispatch(updateBillingAddress(dragIndex, hoverIndex))
        },
        updateExpandedAddress: (key) => {
            dispatch({type: UPDATE_EXPANDED_ADDRESS, key: key})
        }
    })
)
@ui({
    state: {
        country: OPTION_USA,
        showAllAddresses: false,
        maxAddressIndex: 10
    },
    reducer: (state, action) => {
        switch (action.type) {
            case UPDATE_ADDRESS_COUNTRY:
                return state.set('country', action.country)
        }
        return state;
    }
})
@withStyles(styles)
class AddressesFormContent extends PureComponent {

    componentDidMount() {
        this.props.getCompanyCountry(this.props.ui.country);
    }

    addressIsParent(index) {
        return index === 0 && this.props.hasParentAddress
    }

    customerHasMoreAddresses(fields) {
        return !this.props.ui.showAllAddresses && fields.length > (this.props.ui.maxAddressIndex + 1);
    }

    showAllAddressesIfMaxAddressesExceeded(addressCount) {
        if (!this.props.ui.showAllAddresses && addressCount === (this.props.ui.maxAddressIndex + 1)) {
            this.props.updateUI('showAllAddresses', true);
        }
    }

    renderAddressPanels(fields) {
        if (fields.length === 1 && !this.props.hasParentAddress) {
            return <Grid item style={{width: '100%'}}>
                <EachAddressContent
                    fields={fields}
                    index={0}
                    address="service_addresses[0]"
                    disableFields={false}
                    isHousecall={false}
                />
            </Grid>
        } else {
            return fields.map((address, index) => {

                if (!this.props.ui.showAllAddresses && index > this.props.ui.maxAddressIndex) {
                    return;
                }

                let addressKey = `pro_address_${index}`;
                return <AddressExpansionPanel
                    key={addressKey}
                    expandKey={addressKey}
                    index={index}
                    fields={fields}
                    address={address}
                    isParent={this.addressIsParent(index)}
                    updateBillingAddress={this.props.updateBillingAddress}
                />
            })
        }
    }

    renderShowMoreAddress(fields) {
        if (this.customerHasMoreAddresses(fields)) {
            return <Grid container item xs={12} justify="flex-end">
                <Button color="primary"
                        className={this.props.classes.buttonMargin}
                        onClick={() => {
                            this.props.updateUI('showAllAddresses', true)
                        }}>
                    Show All
                </Button>
            </Grid>
        }
    }

    onClickAddAddress(fields) {

        if (this.customerHasMoreAddresses(fields)) {
            let newMaxIndex = this.props.ui.maxAddressIndex + 1;
            this.props.updateExpandedAddress(`pro_address_${newMaxIndex}`);
            this.props.updateUI('maxAddressIndex', newMaxIndex);
            fields.insert(newMaxIndex, {})

        } else {
            this.showAllAddressesIfMaxAddressesExceeded(fields.length);
            this.props.updateExpandedAddress(`pro_address_${fields.length}`);
            fields.push({})
        }
    }

    renderAddAddress(fields) {

        return  <Grid item xs={12}>
            <Button color="primary"
                    variant="outlined"
                    className={this.props.classes.addAddressButtonOneAddress}
                    onClick={() => {
                        this.onClickAddAddress(fields)
                    }}
            >
                + Address
            </Button>
        </Grid>
    }

    render() {
        const {classes} = this.props;

        const renderAddresses = ({fields, meta: {error, submitFailed}}) => {

            return <Grid container>
                {this.renderAddressPanels(fields)}
                {this.renderShowMoreAddress(fields)}
                {this.renderAddAddress(fields)}
            </Grid>
        };

        const renderHousecallAddresses = ({fields, meta: {error, submitFailed}}) => {

            return <Grid container>
                {fields.map((address, index) => (
                    <AddressExpansionPanel
                        key={`housecall_address_${index}`}
                        expandKey={`housecall_address_${index}`}
                        index={index}
                        fields={fields}
                        address={address}
                        isHousecall={true}
                    />
                ))}
            </Grid>
        };

        return <React.Fragment>
            <SectionTitle
                name='Address'
                icon={<AddressIcon/>}
            />
            <div className={classes.addressPadding}/>
            <FieldArray name="addresses" component={renderHousecallAddresses}/>
            <div className={classes.addressPadding}/>
            <FieldArray name="service_addresses" component={renderAddresses}/>
        </React.Fragment>
    }
}

export default AddressesFormContent
